import {
  GET_PARAINAGES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_PARAINAGE_SUCCESS,
  ADD_PARAINAGE_FAIL,
  
  UPDATE_PARAINAGE_SUCCESS,
  UPDATE_PARAINAGE_FAIL,
} from "./actionType";

const INIT_STATE = {
  parainages: [],
  error: {},
};

const Parainage = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PARAINAGES:
          return {
            ...state,
            parainages: action.payload.data,
            isParainageCreated: false,
            isParainageSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PARAINAGES:
          return {
            ...state,
            error: action.payload.error,
            isParainageCreated: false,
            isParainageSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_PARAINAGE_SUCCESS:
      return {
        ...state,
        isParainageCreated: true,
        parainages: [...state.parainages, action.payload.data],
        isParainageAdd: true,
        isParainageAddFail: false
      };

    case ADD_PARAINAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        isParainageAdd: false,
        isParainageAddFail: true
      };

    case UPDATE_PARAINAGE_SUCCESS:
      return {
        ...state,
        parainages: state.parainages.map(parainage =>
          parainage.id === action.payload.id
            ? { ...parainage, ...action.payload }
            : parainage
        ),
        isParainageUpdate: true,
        isParainageUpdateFail: false
      };

    case UPDATE_PARAINAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        isParainageUpdate: false,
        isParainageUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Parainage;
